import { usePageTitle } from '@calendly/hooks'
import { parseQuery } from '@calendly/http-tools'
import { I18n } from '@calendly/i18n'
import { ArrowChevronLeftMiniIcon } from '@calendly/ui/components/icons'
import { PageHeader } from '@calendly/ui/components/page-header'
import { useSelector } from 'react-redux'

import { EyebrowBackButton } from 'components/page_elements'
import { useProductRefreshAppShell } from 'features/app_shell/product_refresh/useProductRefreshAppShell'
import { isAdminOrOwnerOrGroupAdminSelector } from 'selectors/current_user'
import { workflowsOwnerNameSelector } from 'selectors/workflows'
import { publisherWorkflowsT } from 'services/workflows/publisher_workflows_i18n'
import { appWorkflowListUrl, outlookConnectedPageUrl } from 'services/workflows/url'

const getBackToRoute = (owner, isAdminOrOwner, isWorkflowsAppShellRebrand) => {
  const queryParams = parseQuery(window.location.search)
  const { backTo } = queryParams
  switch (backTo) {
    case 'integrations':
      return outlookConnectedPageUrl
    default:
      return appWorkflowListUrl(owner, isAdminOrOwner, isWorkflowsAppShellRebrand)
  }
}

export const Header = ({ owner }) => {
  const ownerName = useSelector(workflowsOwnerNameSelector)
  const isAdminOrOwnerOrGroupAdmin = useSelector(isAdminOrOwnerOrGroupAdminSelector)
  const isWorkflowsAppShellRebrand = useProductRefreshAppShell()
  const title = {
    team: publisherWorkflowsT('publisher.workflows.workflow_templates.teams.title', isWorkflowsAppShellRebrand),
    organization: I18n.t(isWorkflowsAppShellRebrand
      ? 'publisher.workflows_app_shell_rebrand.admin.managed_workflows.title'
      : 'publisher.admin.managed_workflows.title'
    )
  }[owner.type] || publisherWorkflowsT('publisher.workflows.workflow_templates.title', isWorkflowsAppShellRebrand)

  usePageTitle(`${title} - Calendly`)

  return (
    <PageHeader
      title={title}
      description={owner.type !== 'organization' && ownerName}
      eyebrow={(
        <EyebrowBackButton to={getBackToRoute(owner, isAdminOrOwnerOrGroupAdmin, isWorkflowsAppShellRebrand)}>
          <ArrowChevronLeftMiniIcon />
          {I18n.t('publisher.action.back')}
        </EyebrowBackButton>
      )}
    />
  )
}
